import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=fbdfdc34&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdfdc34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbdfdc34')) {
      api.createRecord('fbdfdc34', component.options)
    } else {
      api.reload('fbdfdc34', component.options)
    }
    module.hot.accept("./MessageComponent.vue?vue&type=template&id=fbdfdc34&scoped=true", function () {
      api.rerender('fbdfdc34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageComponent.vue"
export default component.exports